import cx from 'classnames';
import { Fragment } from 'react';

import BPImage from '../../ui/v2/image';
import { useAppContext } from '../../providers/app-context';
import useTranslation from 'next-translate/useTranslation';
import useGetPaymentMethods from '../../../hooks/use-get-payment-method';

export const getAllowedMethodLogo = (method: string, qtt = 0) => {
  let imageSizeRatio = 1.4;

  if (qtt > 0) {
    imageSizeRatio = imageSizeRatio - qtt * 0.1;
  }

  switch (method) {
    case 'ATM':
      return (
        <BPImage
          alt="ATM"
          key="ATM"
          layout="fixed"
          src={`${process.env.PUBLIC_PREFIX}/svg/icons/MB-color.svg`}
          className={cx('h-5')}
          height={15 * imageSizeRatio}
          width={20 * imageSizeRatio}
        />
      );
    case 'MBW':
      return (
        <BPImage
          alt="MBWay"
          key="MBW"
          layout="fixed"
          src={`${process.env.PUBLIC_PREFIX}/svg/icons/MBWAY-color.svg`}
          className={cx('h-5')}
          height={20 * imageSizeRatio}
          width={25 * imageSizeRatio}
        />
      );
    case 'STP':
      return (
        <Fragment key="STP">
          <BPImage
            layout="fixed"
            alt="visa"
            src={`${process.env.PUBLIC_PREFIX}/svg/icons/visa-color.svg`}
            className={cx('h-5')}
            height={22 * imageSizeRatio}
            width={27 * imageSizeRatio}
          />
          <BPImage
            layout="fixed"
            alt="mastercard"
            src={`${process.env.PUBLIC_PREFIX}/svg/icons/mastercard-color.svg`}
            className={cx('h-5')}
            height={15 * imageSizeRatio}
            width={20 * imageSizeRatio}
          />
        </Fragment>
      );
    case 'PAL':
      return (
        <BPImage
          key="PAL"
          alt="PAL"
          layout="fixed"
          src={`${process.env.PUBLIC_PREFIX}/svg/icons/paypal-color.svg`}
          className={cx('h-3')}
          height={20 * imageSizeRatio}
          width={40 * imageSizeRatio}
        />
      );
    case 'BTR':
      return (
        <BPImage
          alt="BTR"
          key="BTR"
          layout="fixed"
          src={`${process.env.PUBLIC_PREFIX}/svg/icons/BTR-color.svg`}
          className={cx('h-5')}
          height={25 * imageSizeRatio}
          width={35 * imageSizeRatio}
        />
      );
    case 'EPS':
      return (
        <BPImage
          key="EPS"
          alt="EPS"
          layout="fixed"
          src={`${process.env.PUBLIC_PREFIX}/svg/icons/eps-color.svg`}
          className={cx('h-5')}
          height={20}
          width={25}
        />
      );
    case 'IDL':
      return (
        <BPImage
          key="IDL"
          alt="IDL"
          layout="fixed"
          src={`${process.env.PUBLIC_PREFIX}/svg/icons/ideal-color.svg`}
          className={cx('h-5')}
          height={17}
          width={25}
        />
      );
    case 'BCT':
      return (
        <BPImage
          key="BCT"
          alt="BCT"
          layout="fixed"
          src={`${process.env.PUBLIC_PREFIX}/svg/icons/bancontact-color.svg`}
          className={cx('h-5')}
          height={17}
          width={25}
        />
      );
    case 'ALM':
      return (
        <BPImage
          key="ALM"
          alt="ALM"
          layout="fixed"
          src={`${process.env.PUBLIC_PREFIX}/svg/icons/alma-color.svg`}
          className={cx('h-5')}
          height={17}
          width={25}
        />
      );
    case 'KLA':
      return (
        <BPImage
          key="KLA"
          alt="KLA"
          layout="fixed"
          src={`${process.env.PUBLIC_PREFIX}/svg/icons/klarna-color.svg`}
          className={cx('h-5')}
          height={17 * imageSizeRatio}
          width={25 * imageSizeRatio}
        />
      );
    case 'VIB':  // only to display logo
      return (
        <BPImage
          alt="VIB"
          key="VIB"
          layout="fixed"
          src={`${process.env.PUBLIC_PREFIX}/svg/icons/BTR-color.svg`}
          className={cx('h-5')}
          height={25 * imageSizeRatio}
          width={35 * imageSizeRatio}
        />
      );
    default:
      return null;
  }
};

const AvailablePaymentOptions = ({ isPP }) => {
  const { shippingLocation } = useAppContext();
  const { t } = useTranslation();
  let paymentMethods = useGetPaymentMethods(shippingLocation);
  const isUkWebsite = process.env.NEXT_PUBLIC_HOST?.includes('.co.uk');

  if (isPP && isUkWebsite) {
    paymentMethods = paymentMethods.filter(
      (item) => !item.alt.includes('klarna')
    );
  }

  return (
    <ul
      className={cx(
        'list-none',
        'grid gap-2 justify-between items-center',
        { 'grid-cols-5': paymentMethods.length <= 5 },
        { 'grid-cols-4': paymentMethods.length > 5 }
      )}
    >
      {paymentMethods.map((item) => (
        <li key={item.alt}>
          <BPImage
            className="h-6"
            src={item.srcColor}
            alt={t(item.alt)}
            height={item.height}
            width={item.width}
          />
        </li>
      ))}
    </ul>
  );
};

export default AvailablePaymentOptions;
